import React from 'react'
import styled from 'styled-components'
import { Row } from '@appearance/styled'
import * as Utils from '@services/utils'
import FilterBox from '@components/Table/FilterBox'
import DateFilters from '@components/Table/DateFilters'
import { Flex1, Flex2 } from '@appearance/styled'

export default ({
    filters,
    setSelectedFilters,
    collection,
    selectedFilters,
    withDateFilters,
    fromDate,
    toDate,
    changeFromDate,
    changeToDate,
}) => {
    const updateFilters = (name, selected) => {
        const newFilters = Object.assign({}, selectedFilters)

        if (selected && selected.length > 0) {
            newFilters[name] = selected.map((sel) => sel)
        } else {
            if (newFilters[name]) {
                delete newFilters[name]
            }
        }
        setSelectedFilters(newFilters)
    }

    return (
        <BottomContainer>
            {filters &&
                Utils.chunk(filters, 3).map((filtersChunk, row_i) => (
                    <Row key={`row_ic double_${row_i}`}>
                        {filtersChunk.map((filter, i) => (
                            <FilterBox
                                key={'filter_' + i}
                                filter={filter}
                                updateFilters={updateFilters}
                                selectedFilters={selectedFilters}
                                collection={collection}
                            />
                        ))}
                        {filtersChunk.length === 2 && <Flex1 />}
                        {filtersChunk.length === 1 && <Flex2 />}
                    </Row>
                ))}
            {withDateFilters && (
                <DateFilters
                    fromDate={fromDate}
                    changeFromDate={changeFromDate}
                    toDate={toDate}
                    changeToDate={changeToDate}
                />
            )}
        </BottomContainer>
    )
}

const BottomContainer = styled.div`
    margin-top: 1rem;
    margin-bottom: 10px;
    width: 100%;
`
